import Api from 'api';
import React from "react";
import './_styles/index.scss';
import Header from './_header';
import Summary from './_summary';
import Products from './_products';
import OtherProducts from './_items';
import { connect } from 'react-redux';
import { Navigation, Footer } from 'components';
import { actions, selectors } from 'redux-store';

class UserCart extends React.Component {

  constructor(props) {
    super(props);
    this.api = new Api();
  }

  componentDidMount = () => {
    document.body.classList.remove('modal-open');
    const { products=[] } = this.props;
    if (!products.empty()) return null;
    return this.fetch_api_data();
  }

  onRemoveItem = (handle) => {
    if (!handle) return null;
    return this.props.remove_cart_item(handle);
  }

  onChangeQuantity = (quantity,handle) => {
    const payload = { quantity, handle };
    return this.props.set_cart_item_quantity(payload);
  }

  fetch_api_data = async () => {

    const { docs = [] } = await this.api.fetch('products','all','');

    const products = docs.map(a => ({ ...a.data(), id: a.id }));

    return this.props.update_product_list(products);

  }

  render() {
    return (
      <section className='Section-Cart'>

        <Navigation/>

        <div className="Cart-Wrapper">

          <Header
            count={this.props.count}
            goBack={this.props.history.goBack}
          />

          <Products
            cartItems={this.props.cart}
            otherProducts={this.props.products}
            onRemoveItem={this.onRemoveItem}
            onChangeQuantity={this.onChangeQuantity}
          />

          <OtherProducts data={this.props.products}/>

          <Summary/>

        </div>

        <Footer/>

      </section>
    );
  }
}

const mapStateToProps = ({ cart, cache }) => ({
  cart: cart.cart_items,
  products: cache.product_list,
  count: selectors.cart_count(cart)
});

export default  connect(mapStateToProps,{...actions})(UserCart);
